import { CellContext } from '@tanstack/react-table';
import { ColumnConfig } from 'components/NewBaseTable/NewBaseTable';
import Typography from 'components/Typography/Typography';
import { PartQuote, SFOrderHistory, TableColumnConfigs, TwoWayOrderHistoryData } from 'types';
import {
  OrderIcon,
  OrderIconWrapper,
  POPrice,
  POPriceWrapper,
  PurchaseOrder,
  OrderIconContainer,
  Status
} from './NewSFOrdersTableStyled';
import ReorderIcon from '../../icons/img/reorder.svg';
import ShipToIconBlue from '../../icons/img/truck_short_blue.svg';
import { generateIcon } from 'common/pages/fleetV2/machine/aseptic/views/MachineHealth/components/SingleSessionSteps/utils';
import { Button, TooltipWrapper } from 'components';
import { Order } from 'types/machine-health/widget-table';
import { DetailIcon } from 'icons/indexed-icons/DetailIcon';
import { Ellipsys } from 'icons/indexed-icons/Ellipsys';
import theme from 'common/theme';
import QuoteRowContextMenu from './QuoteRowContextMenu';
import { TFunction } from 'i18next';

interface TwoWayOrderProps {
  addItemsToCart?: (order: TwoWayOrderHistoryData) => void;
  showOrderModal?: (order: TwoWayOrderHistoryData) => void;
  formatPODate?: (date: string) => string;
  t: (key: string) => string;
}
interface OrderProps {
  addItemsToCart: (order: SFOrderHistory) => void;
  showOrderModal: (order: SFOrderHistory) => void;
  formatPODate: (date: string) => string;
  t: (key: string) => string;
}
interface QuoteProps {
  formatPODate: (date: string) => string;
  t: TFunction<["fpns"], undefined>;
  showQuoteModal: (quote: PartQuote) => void;
  contextMenuPosition: { top: number; left: number } | null;
  openContextMenu: (position: { top: number; left: number }, quote: PartQuote) => void;
  closeContextMenu: () => void;
  selectedQuote: PartQuote | null;
  handleAddQuoteToCart: (quote: PartQuote) => void;
  handleViewQuoteDetails: (quote: PartQuote) => void;
  handleDeleteQuote?: (quote: PartQuote) => void;
}
// const row = cellValue.row.original as UserTypes;
export const generateTwoWayColumnConfigs = ({
  addItemsToCart,
  showOrderModal,
  formatPODate,
  t
}: TwoWayOrderProps): ColumnConfig[] => {
  const addSpaceAfterComma = (str: string | undefined | null): string => {
    if (!str || typeof str !== 'string') {
      return str || '';
    }

    return str.replace(/,\s*/g, ', ');
  };
  return [
    {
      id: 'action',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: ({ row, getValue }) => {
        return (
          <div className={row.getCanExpand() ? 'parent-cell' : 'child-cell'}>
            {row.getCanExpand() ? (
              <Button
                variant="text"
                {...{
                  onClick: row.getToggleExpandedHandler(),
                  style: { cursor: 'pointer' }
                }}
              >
                {row.getIsExpanded() ? generateIcon('chevron down') : generateIcon('chevron right')}
              </Button>
            ) : (
              ' '
            )}
          </div>
        );
      }
    },
    {
      id: 'orderNumber',
      header: 'Order no.',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'quoteNumber',
      header: 'Quote no.',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'poNumber',
      header: 'PO number',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <Typography color="darkGrey" mb="0.5rem" as="a">
          {cellValue.getValue()}
        </Typography>
      )
    },
    {
      id: 'productCount',
      header: '# of products',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <POPriceWrapper>
          <POPrice>{addSpaceAfterComma(cellValue.getValue())}</POPrice>
        </POPriceWrapper>
      )
    },
    {
      id: 'totalPrice',
      header: 'Total price',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <POPriceWrapper>
          <POPrice>{addSpaceAfterComma(cellValue.getValue())}</POPrice>
        </POPriceWrapper>
      )
    },
    {
      id: 'orderDate',
      header: 'Order date',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) =>
        formatPODate && formatPODate(cellValue.getValue())
    },
    {
      id: 'status',
      header: 'Status',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <>
          <Status>{cellValue.getValue()}</Status>
        </>
      )
    },
    {
      id: 'isDummy',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => <></>
    },
    {
      id: 'isDummy1',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <OrderIconContainer>
          <PurchaseOrder
            onClick={() => {
              showOrderModal?.(cellValue.row.original as SFOrderHistory);
            }}
          >
            
            <TooltipWrapper
                Tooltip={
                  'See Order Details'
                }
                textColor={theme.colors.black}
                backGroundColor={theme.colors.white}
              >
                <OrderIconWrapper marginLeft={'0'} isClickable={true}>
                 <DetailIcon />
               </OrderIconWrapper>
              </TooltipWrapper>
          </PurchaseOrder>
          <PurchaseOrder
            onClick={() => {
              addItemsToCart?.(cellValue.row.original as TwoWayOrderHistoryData);
            }}
          >
              <TooltipWrapper
                Tooltip={
                  'Reorder'
                }
                textColor={theme.colors.black}
                backGroundColor={theme.colors.white}
              >
                <OrderIconWrapper marginLeft={'0'} isClickable={true}>
                  <OrderIcon src={ReorderIcon} />
                </OrderIconWrapper>
              </TooltipWrapper>
            
          </PurchaseOrder>
        </OrderIconContainer>
      )
    }
  ];
};
export const generateTwoWayQuotesColumnConfigs = ({
  formatPODate,
  t,
  showQuoteModal,
  contextMenuPosition,
  openContextMenu,
  closeContextMenu,
  selectedQuote,
  handleAddQuoteToCart,
  handleViewQuoteDetails,
  handleDeleteQuote
}: QuoteProps): ColumnConfig[] => {
  return [
    {
      id: 'action',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: ({ row, getValue }) => {
        return (
          <div className={row.getCanExpand() ? 'parent-cell' : 'child-cell'}>
            {row.getCanExpand() ? (
              <Button
                variant="text"
                {...{
                  onClick: row.getToggleExpandedHandler(),
                  style: { cursor: 'pointer' }
                }}
              >
                {row.getIsExpanded() ? generateIcon('chevron down') : generateIcon('chevron right')}
              </Button>
            ) : (
              ' '
            )}
          </div>
        );
      }
    },
    {
      id: 'quoteNumber',
      header: 'Quote no.',
      isEnableSorting: true,
      isSelected: true,

      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'productCount',
      header: '# of products',
      isEnableSorting: true,
      isSelected: true,

      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'totalPrice',
      header: 'Total price',
      isEnableSorting: true,
      isSelected: true,

      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => {
        const currenciesByCode: Record<string, string> = { usd: '$', eur: '€', gbp: '£' };
        const quote = cellValue.row.original as PartQuote;
        const totalPrices = quote.totalPrice; 
       
        if (Object.keys(totalPrices).length === 0) {
          return 'N/A';
        }
        const formattedPrices = Object.entries(totalPrices)
          .map(([currency, amount]) => `${currenciesByCode[currency.toLowerCase()] || currency}${amount}`)
          .join(' / ');
        return formattedPrices;

      }
    },
    {
      id: 'createDate',
      header: 'Creation date',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) =>
        formatPODate(cellValue.getValue())
    },
    {
      id: 'status',
      header: 'Status',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => {
        return (
          <>
            <Status statusColor={cellValue.getValue()}>{cellValue.getValue()}</Status>
          </>
        );
      }
    },
    {
      id: 'expirationDate',
      header: 'Expiry date',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) =>
        formatPODate(cellValue.getValue())
    },
    {
      id: 'isDummy',
      header: '',
      isEnableSorting: false,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => {
        const quote = cellValue.row.original as PartQuote;
        
        const handleEllipsysClick = (e: React.MouseEvent<HTMLDivElement>) => {
          e.preventDefault();
          e.stopPropagation();
          
          // Calculate position relative to the ellipsys icon
          const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
          const position = {
            top: rect.bottom + 5,
            left: rect.left
          };
          
          openContextMenu(position, quote);
        };

        return (
          <>
            <PurchaseOrder onClick={handleEllipsysClick}>
              <OrderIconWrapper marginLeft="0" isClickable={true}>
                <Ellipsys />
              </OrderIconWrapper>
            </PurchaseOrder>
            
            {selectedQuote && selectedQuote === quote && (
              <QuoteRowContextMenu
                quote={quote}
                position={contextMenuPosition}
                onClose={closeContextMenu}
                onAddToCart={handleAddQuoteToCart}
                onViewDetails={handleViewQuoteDetails}
                onDeleteQuote={handleDeleteQuote}
              />
            )}
          </>
        );
      }
    }
  ];
};
export const generateColumnConfigs = ({
  addItemsToCart,
  showOrderModal,
  formatPODate,
  t
}: OrderProps): ColumnConfig[] => {
  const addSpaceAfterComma = (str: string | undefined | null): string => {
    if (!str || typeof str !== 'string') {
      return str || '';
    }

    return str.replace(/,\s*/g, ', ');
  };
  return [
    {
      id: 'poDate',
      header: 'Date',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) =>
        formatPODate(cellValue.getValue())
    },
    {
      id: 'poNumber',
      header: 'PO Number',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'orderBy',
      header: 'Order by',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <Typography color="darkGrey" mb="0.5rem" as="a">
          {cellValue.getValue()}
        </Typography>
      )
    },
    {
      id: 'totalPrice',
      header: 'Price',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <POPriceWrapper>
          <POPrice>{addSpaceAfterComma(cellValue.getValue())}</POPrice>
          <OrderIconWrapper
            isClickable={true}
            onClick={() => {
              addItemsToCart(cellValue.row.original as SFOrderHistory);
            }}
            title="Reorder"
          >
            <OrderIcon src={ReorderIcon} />
          </OrderIconWrapper>
        </POPriceWrapper>
      )
    },
    {
      id: 'isDummy',
      header: 'Details',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <>
          <PurchaseOrder
            onClick={() => {
              showOrderModal(cellValue.row.original as SFOrderHistory);
            }}
          >
            <OrderIconWrapper marginLeft={'0'} isClickable={true}>
              <OrderIcon src={ShipToIconBlue} />
            </OrderIconWrapper>
            {t('see_order_details') as string}
          </PurchaseOrder>
        </>
      )
    }
  ];
};

export const generateQuotesColumnConfigs = ({
  formatPODate,
  t,
  showQuoteModal
}: QuoteProps): ColumnConfig[] => {
  return [
    {
      id: 'requestDate',
      header: 'Date',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) =>
        formatPODate(cellValue.getValue())
    },
    {
      id: 'requestedBy',
      header: 'Requested By',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => cellValue.getValue()
    },
    {
      id: 'totalPrice',
      header: 'Price',
      isEnableSorting: true,
      isSelected: true,
      renderer: () => <POPriceWrapper>N/A</POPriceWrapper>
    },
    {
      id: 'isDummy',
      header: 'Details',
      isEnableSorting: true,
      isSelected: true,
      renderer: (cellValue: CellContext<TableColumnConfigs, string>) => (
        <>
          <PurchaseOrder
            onClick={() => {
              showQuoteModal(cellValue.row.original as PartQuote);
            }}
          >
            <OrderIconWrapper marginLeft="0" isClickable={true}>
              <OrderIcon src={ShipToIconBlue} />
            </OrderIconWrapper>
            {t('see_details') as string}
          </PurchaseOrder>
        </>
      )
    }
  ];
};
